export default __webpack_public_path__ + "static/media/Send.8ce81ba5.svg";